export default "__VITE_ASSET__BvK1RBey__"